import { render, staticRenderFns } from "./ForcPeerReviewClassDistributionComparison.vue?vue&type=template&id=89072dde&scoped=true&"
import script from "./ForcPeerReviewClassDistributionComparison.vue?vue&type=script&lang=js&"
export * from "./ForcPeerReviewClassDistributionComparison.vue?vue&type=script&lang=js&"
import style0 from "./ForcPeerReviewClassDistributionComparison.vue?vue&type=style&index=0&id=89072dde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89072dde",
  null
  
)

export default component.exports